/**
 * SEOquake
 *
 * Injects a visible SEO toolbar and stamps <body> with its own attributes, including a
 * per-install UUID.
 * Observed on version 3.13.5.
 */
import { probeSelector, probeAttributePrefix } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'akdgnmcogleenhbclghghlkkdndkjdjc';
export const seoquake: ExtensionDefinition = {
  id: ID,
  name: 'SEOquake',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'body[datasquuid] is a per-install identifier. That is worse than detection: it is ' +
    'a stable cross-site identifier the extension hands to every page it loads on.',
  signals: [
    { id: 'dom-seobar', kind: 'dom',
      description: 'Look for #sqseobar2 — the injected SEO toolbar container.',
      weight: 1, run: () => probeSelector('#sqseobar2, [class^="sqseobar2"]', { timeoutMs: 1500 }) },
    { id: 'dom-body-uuid', kind: 'dom',
      description: 'Check <body datasquuid> — a per-install UUID readable by every page.',
      weight: 1, run: () => probeAttributePrefix('datasq') },
  ],
};
